<template>
  <a-modal
    title="新增会员"
    :visible="visible"
    width="600px"
    okText="立即新增"
    @ok="handleOk"
    @cancel="$emit('update:visible', false)"
  >
    <a-form :form="form" layout="vertical" style="margin-left: 130px">
      <a-form-item
        :label="item.label"
        v-for="item in memberFormList"
        :key="item.name"
      >
        <a-input
          v-if="item.type === 'input'"
          v-decorator="[
            item.name,
            { rules: [{ required: item.required, message: item.message }] },
          ]"
          style="width: 300px"
        />
        <a-radio-group
          v-else-if="item.type === 'radio'"
          v-decorator="[
            item.name,
            { rules: [{ required: item.required, message: item.message }] },
          ]"
        >
          <a-radio value="普通会员">普通会员</a-radio>
          <a-radio value="高级会员">高级会员</a-radio>
        </a-radio-group>
        <a-input-number
          v-else-if="item.type === 'number'"
          v-decorator="[
            item.name,
            { rules: [{ required: item.required, message: item.message }] },
          ]"
          style="width: 300px"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
const memberFormList = [
  {
    label: '会员卡',
    name: 'typeName',
    type: 'radio',
    required: true,
    message: '请选择会员卡',
  },
  {
    label: '定价',
    name: 'price',
    type: 'number',
    required: true,
    message: '请输入价格',
  },
  {
    label: '权益',
    name: 'benefit',
    type: 'input',
    required: true,
    message: '请输入权益',
  },
  {
    label: '开通人数',
    name: 'userNum',
    type: 'number',
    required: true,
    message: '请输入开通人数',
  },
]
export default {
  name: 'addMemberModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      memberFormList,
    }
  },
  methods: {
    handleOk() {
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          this.$api.createMemberCard(values).then(res => {
            if (res.code === 0) {
              this.$message.success('新增会员成功')
              this.$emit('update:visible', false)
              this.$emit('refresh')
            }
          })
        }
      })
    },
  },
}
</script>